<script setup lang="ts">
import logoUrl from '@/assets/ui/ur-logo.svg';
</script>

<template>
  <header class="header">
    <a class="header__home" href="https://www.rochester.edu/">
      <img :src="logoUrl" alt="University of Rochester" class="header__logo" width="239" height="56" />
    </a>
    <h1 class="visually-hidden">Explore Maps</h1>
  </header>
</template>

<style scoped>
/* Matches the production header: logo only, 239px wide, 17px padding. */
.header {
  position: relative;
  z-index: 3;
  display: flex;
  align-items: center;
  height: var(--header-height);
  padding: 0 20px;
  background: var(--surface);
  border-bottom: 1px solid var(--border);
}

.header__home {
  display: flex;
  border-radius: 4px;
}

.header__logo {
  display: block;
  width: 239px;
  height: auto;
}

@media (max-width: 480px) {
  .header {
    padding: 0 14px;
  }

  .header__logo {
    width: 180px;
  }
}
</style>
